export default __webpack_public_path__ + "3MGJLhc-logo_mini_white.svg";